export default "__VITE_PUBLIC_ASSET__0e8f6ac3__"